import { jsx as _jsx } from "preact/jsx-runtime";
import { configureStore } from '@reduxjs/toolkit';
import { storeOptions } from '@widgets/QuickPayWrapper/store';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { Suspense, useContext, useMemo } from 'react';
import { OptionsCTX, optionsDefaults } from '@widgets/QuickPayWrapper/context/Options';
import LoadingSpinner from '@widgets/shared/components/LoadingSpinner';
import { Provider } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@widgets/QuickPayWrapper/store/hooks';
import { getQuickPayAppleState, getQuickPayGoogleState, setQuickPayState, } from '@widgets/QuickPayWrapper/store/reducers/quickPay';
import QuickPay from '@widgets/shared/components/QuickPay';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
function Element() {
    const { analyticsTitle, analyticsUrl, analyticsPath, products, termsAccepted, title, } = useContext(OptionsCTX);
    const appleHidden = useAppSelector(getQuickPayAppleState);
    const googleHidden = useAppSelector(getQuickPayGoogleState);
    const onAppleAvailable = useGlobalEvent('apple.available');
    const onGoogleAvailable = useGlobalEvent('google.available');
    onAppleAvailable(() => setQuickPayState('apple', false));
    onGoogleAvailable(() => setQuickPayState('google', false));
    const dispatch = useAppDispatch();
    return (_jsx(QuickPay, { products: products, termsAccepted: termsAccepted, analyticsTitle: analyticsTitle, analyticsUrl: analyticsUrl, analyticsPath: analyticsPath, title: title, onClickedWhenDisabled: () => { }, handleAppleDidFail: (status) => dispatch(setQuickPayState('apple', status)), handleGoogleDidFail: (status) => dispatch(setQuickPayState('google', status)), appleHidden: appleHidden, googleHidden: googleHidden }));
}
function QuickPayWrapper(props) {
    const { dataset } = props;
    const store = configureStore(storeOptions);
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
        isDayTicket: false,
    }), [formattedAttributes]);
    return (_jsx(Suspense, { fallback: LoadingSpinner, children: _jsx(Provider, { store: store, children: _jsx(OptionsCTX.Provider, { value: formOptions, children: _jsx(Element, {}) }) }) }));
}
export default QuickPayWrapper;
